import { Directive, OnInit, OnDestroy, ElementRef } from "@angular/core";

const activeDialogs: ElementRef<Element>[] = [];

@Directive({
    selector: '[role="dialog"]',
    standalone: true,
})
export class ManagedModalDirective implements OnInit, OnDestroy {
  constructor(private el: ElementRef<Element>) {}

  applyModalState(inModal: boolean): void {
    if (inModal) {
      document.body.classList.add("no-scroll");
    } else {
      document.body.classList.remove("no-scroll");
    }
  }

  ngOnInit(): void {
    activeDialogs.push(this.el);
    this.applyModalState(true);
  }

  ngOnDestroy(): void {
    activeDialogs.pop();
    this.applyModalState(activeDialogs.length !== 0);
  }
}
